module.exports = __webpack_public_path__ + "static/media/pay_paybol.49780905.svg";